import { jsonLD } from '@/shared/integrations/microdata'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { TSection } from '@/shared/types/deprecated-types'
import { TProduct } from '@/shared/types/product-types'

type ProductListSchemaScriptProps = {
	products: TProduct[]
	category: TSection
}

export const ProductListSchemaScript = (props: ProductListSchemaScriptProps) => {
	const { products, category } = props

	return (
		<script
			type="application/ld+json"
			data-label="ItemList"
			dangerouslySetInnerHTML={createMarkup(jsonLD.getListingSchema(category.code, products))}
		/>
	)
}
